"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginMenuOptionProptypes = exports.LoginMenuOptionDataPropTypes = void 0;

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LoginMenuOptionProptypes = {
  PropTypes: {
    theme: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    data: _propTypes.default.arrayOf((0, _propTypes.shape)({
      id: _propTypes.default.string,
      icon: _propTypes.default.string,
      label: _propTypes.default.string,
      redirectUrl: _propTypes.default.string,
      newTab: _propTypes.default.string
    })),
    labelTextColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    hoverBackground: _propTypes.default.oneOf(_constant.ARR_COLORS),
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    accessible: _propTypes.default.bool,
    textType: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    stopPropagation: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    labelTextColor: _constant2.DEFAULT_STYLE.LABEL_COLOR,
    textType: _constant2.DEFAULT_STYLE.SUB,
    hoverBackground: _constant2.DEFAULT_STYLE.HOVER_BACKGROUND,
    background: _constant2.DEFAULT_STYLE.BACKGROUND
  }
};
exports.LoginMenuOptionProptypes = LoginMenuOptionProptypes;
var LoginMenuOptionDataPropTypes = {
  PropTypes: {
    labelTextColor: _propTypes.default.string,
    label: _propTypes.default.string,
    redirectUrl: _propTypes.default.string,
    target: _propTypes.default.string,
    hoverBackground: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    id: _propTypes.default.string,
    stopPropagation: _propTypes.default.bool
  }
};
exports.LoginMenuOptionDataPropTypes = LoginMenuOptionDataPropTypes;